import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { PaymentStatus } from 'src/app/core';
import { AreYouSureComponent } from 'src/app/feature/components';
import { PaymentService } from 'src/app/feature/payment/services';
import { Order, PaginationResult, PaymentEntity } from 'src/app/shared';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.scss'],
})
export class MyOrdersComponent implements OnInit {
  public orders!: Order[];
  private subsink = new SubSink();
  public statuses = PaymentStatus;
  public paymentPagination!: PaginationResult<PaymentEntity>;
  public selectedIndex = 0;

  @ViewChild('myOrdersTabGroup') myOrdersTabGroup!: MatTabGroup;

  // -----------------------Getters & Setters|

  get callPriceOrders(): Order[] {
    return this.orders.filter((order): any => {
      if (order.status === 'calculation') {
        return order;
      }
    });
  }

  get inProgressOrders(): Order[] {
    return this.orders.filter((order): any => {
      return order.status === 'progress';
    });
  }

  get getDoneOrders(): Order[] {
    return this.orders.filter((order): any => {
      return order.status === 'done';
    });
  }

  // -----------------------Constructor|

  constructor(
    private dialogBox: MatDialog,
    private activatedRoute: ActivatedRoute,
    private snackBar: MatSnackBar,
    private paymentService: PaymentService
  ) {
    this.subsink.sink = activatedRoute.data.subscribe((data) => {
      if (data['payments']) {
        this.paymentPagination = data['payments'];
      }
    });
  }

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((paramsMap) => {
      const tabIndex = parseInt(paramsMap.get('index')!);
      if (typeof tabIndex === 'number' && !Number.isNaN(tabIndex)) {
        this.selectedIndex = tabIndex;
      }
    });
  }

  // ----------------------Public Getters & Setters|

  public get finalizedPayments(): PaymentEntity[] {
    const filter = (this.paymentPagination.items || []).filter(
      (payment) =>
        payment.isFinalized && payment.status === PaymentStatus.Payment
    );

    return filter;
  }

  public get progressPayments(): PaymentEntity[] {
    const filter = (this.paymentPagination.items || []).filter((payment) => {
      return (
        payment.status === this.statuses.Implementation ||
        payment.status === this.statuses.Done
      );
    });

    return filter;
  }

  public get deliveredPayments(): PaymentEntity[] {
    const filter = (this.paymentPagination.items || []).filter((payment) => {
      return payment.status === this.statuses.Sent;
    });

    return filter;
  }

  public get canceledPayments(): PaymentEntity[] {
    const filter = (this.paymentPagination.items || []).filter((payment) => {
      return payment.status === this.statuses.Canceled;
    });

    return filter;
  }

  public cancelPayment(id: number) {
    this.subsink.sink = this.dialogBox
      .open(AreYouSureComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.subsink.sink = this.paymentService.cancelPayment(id).subscribe({
            next: (payment) => {
              const index = this.paymentPagination.items.findIndex(
                (payment) => payment.id === id
              );

              if (index < 0) {
                throw new Error('Payment not founded to update on client');
              }

              this.paymentPagination.items[index] = payment;
              this.snackBar.open('سفارش با موفقیت لغو شد', '', {
                duration: 1500,
              });
            },
            error: (err) => {
              this.snackBar.open(
                'مشکلی در لغو سفارش پیش آمد، با پشتیبانی تماس بگیرید',
                'متوجه شدم',
                {
                  duration: 1500,
                }
              );
            },
          });
        }
      });
  }

  // ---------------------Public Methods|
}
